
const LastMinuteCounter = ({ show, counter }) => {
    return (
        <div className={`auction-chat__chat-holder__last-minute-counter ${show ? "auction-chat__chat-holder__last-minute-counter--show" : ""} ${+counter?.split(":")[1] < 30 ? "auction-chat__chat-holder__last-minute-counter--red" : ""} position-absolute start-50 translate-middle-x`}>
            <span className="fw-bold fsize-1">{counter}</span>
        </div>
    );
}

export default LastMinuteCounter;